import React from "react";
import { alpha, Box, Tooltip, Typography } from "@mui/material";

// Props:
// - label: string
// - value: number|string
// - color: hex/string (used for button background)
// - icon: MUI Icon component (optional)
// - actionLabel: string for placeholder button (optional)
// - onActionClick: handler (optional)
const KPICard = ({ label, value, color = "#1976d2", icon: Icon, onActionClick, active = false }) => {
  const handleClick = () => {
    if (typeof onActionClick === "function") onActionClick();
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        flex: 1,
        minWidth: 200,
        borderRadius: "8px",
        p: 2,
        bgcolor: active ? alpha(color, 0.08) : "background.paper",
        border: active ? `2px solid ${alpha(color, 0.5)}` : "1px solid transparent",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        columnGap: 2,
        cursor: onActionClick ? "pointer" : "default",
      }}
    >
      {/* minWidth: 0 lets this flex child shrink below its content width — without it
          a long label (e.g. "Document Categories") wraps to a second line and the card
          grows instead of the text truncating. */}
      <Box sx={{ minWidth: 0, flex: 1, overflow: 'hidden' }}>
        <Tooltip title={label ?? ""} placement="top">
          <Typography variant="overline" noWrap sx={{
            display: 'block',
            color: "text.secondary", letterSpacing: 1,
          }}>
            {label}
          </Typography>
        </Tooltip>
        <Typography variant="h5" noWrap sx={{ fontWeight: 700 }}>
          {value}
        </Typography>
      </Box>
      <Box
        onClick={(e) => {
          e.stopPropagation();
          handleClick();
        }}
        sx={{
          width: 35,
          height: 35,
          minWidth: 35,
          minHeight: 35,
          flexShrink: 0,
          borderRadius: "50% !important",
          backgroundColor: alpha(color, 0.1),
          color: color,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "&:hover": {
            backgroundColor: alpha(color, 0.2),
          },
          cursor: 'pointer'
        }}>
        {Icon ? <Icon /> : null}

      </Box>
    </Box>
  );
};

export default KPICard;
